import React from 'react';
import ItemInfo from './ItemInfo';

const Accessories = ({ item, dataLocale }) => {
    return (
        <div>
            <ItemInfo name={item.name} productId={item.productId} dataLocale={dataLocale} />
            <p className="margin-b15">{dataLocale.THIS_PRODUCT_HAS_NO_CUSTOM_OPTIONS}</p>
        </div>
    );
};

export default Accessories;
